<template>
  <b-button
    :variant="btnVariant"
    :disabled="isDisabled"
    @click="saveAction"
  >
    {{ btnLabel }}
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'SaveButton',
  components: {
    BButton,
  },
  props: {
    btnLabel: {
      type: String,
      default: 'Kaydet',
    },
    saveAction: {
      type: Function,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    btnVariant: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
